// extracted by mini-css-extract-plugin
export default {"agenciesListEmptyScreen":"agenciesListEmptyScreen_ZqSKS","button":"button___aW9"};